<script>
  import Meta from "./Meta.svelte"
  import Header from "./stand/Header.svelte"
  import Icon from "./helpers/Icon.svelte"
  import Footer from "./stand/Footer.svelte"
  import content from "./../data/doc.json"
  import Grid from "./Grid.svelte"
  import {Container,Row,Col,TabContent, TabPane} from 'sveltestrap'
  import viewport from "../stores/viewport.js"
  import Boundary from "../components/helpers/Boundary.svelte"
  let status = 'voter';

  function switchTab() {
    status = 'candidate';
  }

</script>

<Meta />

<section class="cover" style="height:{$viewport.height-80}px;background-image:url('assets/cover.jpeg')">
  <div class="overlay">
    <Header />
    <div class="cover-content">
    </div>
  </div>
</section>
<section class="intro" style="margin-top:-{$viewport.height/2.5}px;">
  <Container>
    <Row>
      <Col sm=12 md=8 lg=7>
        {@html content.title}
        {@html content.intro}
      </Col>
      <Col sm=12 md=4 lg=5>
        <div class="primary-nav">
          <a href="#voters">For Voters</a>
          <a href="#candidates">For Candidates</a>
          <div class="social-share">
            <a target="_new" href="https://www.facebook.com/sharer.php?u={encodeURIComponent(window.location.href)}"><button class="facebook"><Icon name="facebook" stroke="var(--white)" stroke-width=2 width="30" /></button></a>
            <a target="_new" href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fpublications.stand.earth%2Ftrans-mountain%2F&via=standearth&text=Do%20your%20local%20candidates%20support%20the%20Trans%20Mountain%20pipeline%3F%20Click%20here%20to%20find%20out%20which%20candidates%20have%20pledged%20to%20%23StopTMX%2C%20and%20which%20have%20yet%20to%20take%20a%20stand.%20&hashtags=Elxn44"><button class="twitter"><Icon name="twitter" stroke="var(--white)" stroke-width=2 width="30"/></button></a>
          </div>
      </div>
      </Col>
    </Row>
</Container>
</section>

<section class="why" style="background-image:url('assets/image2.jpg');">
  <div class="overlay">
    <Boundary left_spacing='60' color='var(--white)' orientation='triangle'/> 
    <div class="why-content">
      <Container>
        <Row>
          <Col sm=12 md={{size:8, offset:4}} lg={{size:8, offset:4}}>
            {@html content.cover}
          </Col>
        </Row>
      </Container>
    </div>
  </div>
</section>

<section class="actions">
  <div class="navigation">
    <!-- svelte-ignore a11y-missing-content -->
    <a name="candidates"></a>
    <!-- svelte-ignore a11y-missing-content -->
    <a name="voters"></a>
    <TabContent pills on:tab={(e) => (status = e.detail)}>
      <TabPane tabId="voters" active>
        <span slot="tab">
          <h3>FOR VOTERS</h3>
        </span>
        <div id="bdry-left">
          <Boundary left_spacing='50' color='var(--stand-primary)' orientation='triangle'/> 
        </div>
        <div class="voter">
          <Container>
            <Row>
              <Col sm=12>
                
                {@html content.voter_intro}
                <Grid />
              </Col>
            </Row>
          </Container>
          
        </div>
      </TabPane>
      <TabPane tabId="candidates">
        <span slot="tab">
          <h3>FOR CANDIDATES</h3>
        </span>
        <div id="bdry-right">
          <Boundary left_spacing='50' color='var(--stand-primary)' orientation='triangle'/> 
        </div>
        <div class="candidate">
          <Container>
            <Row>
              <Col sm=12>
                
                <div id="form-wrap"><iframe title="candidate-pledge" src="https://act.stand.earth/page/32663/survey/1#pledge?ea.tracking.id=act-page" frameBorder="0" class="inner_wrapper"></iframe></div>
              </Col>
            </Row>
          </Container>
          
        </div>
      </TabPane>
    </TabContent>
  </div>
</section>



<Footer />


<style>
  .cover { 
          background-position:cover;
          width:100%;
          min-width:200px;
          background-position: center; /* Center the image */
          background-repeat: no-repeat; /* Do not repeat the image */
          background-size: cover;
      }

  .cover .overlay {
    width:100%;
    height:100%;
    background:linear-gradient(rgba(181,18,27,0.3),rgba(255,255,255,1));
  }

  .cover-content {
      padding-top:30%;
  }

  #bdry-left {
    width:50%;
    float:left;
    margin-top:-10px;
  }
  #bdry-right {
    width:50%;
    float:right;
    margin-top:-10px;
  }

  @media (max-width:530px) {
    #bdry-left,#bdry-right {
      display:none;
    }
  }

  .intro {
    padding-bottom:20px;
  }

  .why {
    color:var(--white);
    background-position:left; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
  }

  .why .overlay {
    width:100%;
    height:100%;
    background:linear-gradient(.25turn, rgba(18,37,50,0.1), 10%, rgba(18,37,50,1));
  }

  .why-content {
    padding-top:50px;
    padding-bottom:50px;
  }

  .voter, .candidate {
    padding-top:50px;
  }

  .primary-nav {
    font-size:20px;
    padding-top:200px;
    text-align:right;
  }

  @media (max-width:766px) {
    .primary-nav {
      padding-top:30px;
    }
  }

  .primary-nav a {
    display:block;
    width:100%;
    color:var(--stand-primary);
    text-transform:uppercase;
    text-decoration:underline;
    font-family:'Gotham';
    padding-bottom:10px;
  }

  .primary-nav a:hover {
    text-decoration:none;
  }

  .social-share {
    margin-top:20px;
    text-align:right;
    }

  .social-share a {
    display:inline;
  }

  .social-share button {
    padding:2px 10px 5px 10px;
    border-radius:50%;
  }


  button.facebook {
      background:#4267B2;
      font-size:30px;
  }
    button.twitter {
        background:#1DA1F2;
        font-size:30px;
    }

    button:hover {
        background:var(--stand-secondary);
    }


    #form-wrap .inner_wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    @media (min-width: 992px) {
      #form-wrap {
          min-height: 1300px !important;
          clear:both;
      }
    }

    #form-wrap {
      width:100%;
      clear: both;
      position: relative;
      min-height: 1300px;
      overflow: hidden;
      display: block;
    }

</style>